import { Pipe, PipeTransform } from '@angular/core';
import { UserDetail, UserInfo } from '@ca/core/models';

@Pipe({
    name: 'initials',
})
export class InitialsPipe implements PipeTransform {
    transform(userInfo?: UserInfo | UserDetail): string {
        if (userInfo == null || userInfo.firstName === '' || userInfo.lastName === '') {
            return 'NN';
        } else {
            return `${userInfo.firstName ? userInfo.firstName.charAt(0).toUpperCase() : 'N'}${
                userInfo.lastName ? userInfo.lastName.charAt(0).toUpperCase() : 'N'
            }`;
        }
    }
}
